<template>
    <div class="trade-get-started text-center">
        <b-button
            block
            variant="primary"
            size="lg"
            class="mx-auto"
            @click="handleClick"
        >
            Get Started
        </b-button>
        <span class="info">
          Subject to availability. Some restrictions apply.
        </span>
    </div>
</template>

<script>
import './GetStarted.scss';
import './GetStarted.mobile.scss';

export default {
    name: "GetStarted",
    methods: {
        handleClick() {
            this.$emit('click')
        }
    }
}
</script>
